const css = `.routine-calendar-event {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px;
  height: 100%;
  min-height: 24px;
  overflow: hidden;
  border-radius: var(--border-radius);
  border: 1px solid;
}
.routine-calendar-event .event-type {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  border-radius: 4px;
  flex-shrink: 0;
  color: var(--surface-0);
}
.routine-calendar-event .event-type i {
  font-size: var(--font-size-sm);
}
.routine-calendar-event .event-content {
  --text: var(--on-fill-text);
  --text-muted: var(--on-fill-text-muted);
  --danger: var(--on-fill-danger);
  flex: 1;
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  min-height: 24px;
  font-size: var(--font-size-xs);
  line-height: var(--line-height-tight);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.routine-calendar-event .event-content span {
  color: var(--text);
}
@media screen and (max-width: 576px) {
  .routine-calendar-event {
    padding: var(--space-0-5);
    gap: 2px;
    min-height: 20px;
  }
  .routine-calendar-event .event-type {
    display: none;
  }
  .routine-calendar-event .event-content {
    padding: 2px 4px;
    min-height: 18px;
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-medium);
    border-radius: 3px;
  }
  .routine-calendar-event.past-routine {
    opacity: 0.8;
  }
  .routine-calendar-event.past-routine .event-content {
    background-color: var(--surface-100);
    color: var(--surface-700);
    border-left: 2px solid var(--surface-500);
  }
  .routine-calendar-event.past-routine .event-content span {
    color: var(--surface-700);
  }
  .routine-calendar-event.current-routine .event-content {
    background-color: var(--accent-subtle);
    color: var(--accent);
    border-left: 2px solid var(--accent);
  }
  .routine-calendar-event.current-routine .event-content span {
    color: var(--accent);
  }
}

.event-tooltip {
  min-width: 200px;
  padding: 8px;
  background-color: var(--surface-0);
}
.event-tooltip strong {
  display: block;
  margin-bottom: 8px;
  font-size: var(--font-size-sm);
  color: var(--text-color);
  font-weight: var(--font-weight-semibold);
}
.event-tooltip .event-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.event-tooltip .event-details > div {
  display: flex;
  align-items: center;
  gap: 8px;
}
.event-tooltip .event-details > div i {
  font-size: var(--font-size-sm);
  color: var(--text-color-secondary);
}
.event-tooltip .event-details > div span {
  font-size: var(--font-size-xs);
  color: var(--text-color-secondary);
}
@media screen and (max-width: 576px) {
  .event-tooltip {
    min-width: 180px;
    padding: 8px;
  }
  .event-tooltip strong {
    font-size: var(--font-size-xs);
    margin-bottom: var(--space-2);
  }
  .event-tooltip .event-details {
    gap: var(--space-2);
  }
  .event-tooltip .event-details > div {
    gap: var(--space-2);
  }
  .event-tooltip .event-details > div i {
    font-size: var(--font-size-xs);
  }
  .event-tooltip .event-details > div span {
    font-size: var(--font-size-xs);
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
